// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    // Page titles
    'deferred_revenues.page_title': 'Deferred Revenues',
    'deferred-revenue.page.title': 'Deferred Revenues',
    'deferred-revenue.page.create.title': 'Create Deferred Revenue',
    'deferred-revenue.page.all': 'All Deferred Revenues',

    // Buttons
    'deferred-revenue.button.create': 'Create Deferred Revenue',
    'deferred-revenue.button.cancel': 'Cancel',
    'deferred-revenue.button.save': 'Save',
    'deferred_revenues.edit': 'Edit',

    // Labels
    'deferred_revenues.fields.deferral_number': 'Deferral Number',
    'deferred_revenues.fields.deferral_status': 'Status',
    'deferred_revenues.fields.deferral_date': 'Deferral Date',
    'deferred_revenues.fields.service_start_date': 'Service Start Date',
    'deferred_revenues.fields.service_end_date': 'Service End Date',
    'deferred_revenues.fields.entity': 'Entity',
    'deferred_revenues.fields.general_ledger_account': 'Revenue Account',
    'deferred_revenues.fields.deferred_revenue_liability_account': 'Deferred Revenue Liability Account',
    'deferred_revenues.fields.currency': 'Currency',
    'deferred_revenues.fields.total_amount': 'Total Amount',
    'deferred_revenues.fields.recognized_amount': 'Recognized Amount',
    'deferred_revenues.fields.remaining_amount': 'Remaining Amount',
    'deferred_revenues.fields.recognition_frequency': 'Recognition Frequency',
    'deferred_revenues.fields.description': 'Description',
    'deferred_revenues.fields.reference_number': 'Reference Number',
    'deferred_revenues.fields.memo': 'Memo',
    'deferred_revenues.fields.is_recurring': 'Is Recurring',
    'deferred-revenue.label.deferral_date': 'Deferral Date',
    'deferred-revenue.label.service_start_date': 'Service Start Date',
    'deferred-revenue.label.service_end_date': 'Service End Date',
    'deferred-revenue.label.entity_name': 'Entity',
    'deferred-revenue.label.revenue_account': 'Revenue Account',
    'deferred-revenue.label.deferred_revenue_liability_account': 'Deferred Revenue Liability Account',
    'deferred-revenue.label.currency': 'Currency',
    'deferred-revenue.label.total_amount': 'Total Amount',
    'deferred-revenue.label.total_periods': 'Total Periods',
    'deferred-revenue.label.recognition_frequency': 'Recognition Frequency',
    'deferred-revenue.label.description': 'Description',
    'deferred-revenue.label.reference_number': 'Reference Number',
    'deferred-revenue.label.memo': 'Memo',
    'deferred-revenue.label.status': 'Status',
    'deferred-revenue.label.deferral_number': 'Deferral Number',

    // Placeholders
    'deferred-revenue.placeholder.search': 'Search deferred revenues...',
    'deferred_revenues.search_placeholder': 'Search deferred revenues...',
    'deferred-revenue.placeholder.select_status': 'Select status',

    // Search
    'deferred-revenue.search.title': 'Search Deferred Revenues',
    'deferred-revenue.search.keyword': 'Keyword',
    'deferred-revenue.search.placeholder': 'Search deferred revenues...',

    // Filters
    'deferred_revenues.filters.status': 'Status',
    'deferred_revenues.filters.date_from': 'Date From',
    'deferred_revenues.filters.date_to': 'Date To',

    // Messages
    'deferred-revenue.message.created_successfully': 'Deferred revenue created successfully',
    'deferred_revenues.validation.form_errors': 'Please correct the errors below',

    // Errors
    'deferred-revenue.error.message.error_loading_page': 'Sorry, there was an error loading the deferred revenue page.',
    'deferred-revenue.link.retry': 'Click here to retry',

    // Status
    'deferred_revenues.status.pending': 'Pending',
    'deferred_revenues.status.partial': 'Partial',
    'deferred_revenues.status.complete': 'Complete',
    'deferred_revenues.status.cancelled': 'Cancelled',
    'deferred_revenues.status.PENDING': 'Pending',
    'deferred_revenues.status.PARTIAL': 'Partial',
    'deferred_revenues.status.COMPLETE': 'Complete',
    'deferred_revenues.status.CANCELLED': 'Cancelled',
    'deferred-revenue.status.active': 'Active',
    'deferred-revenue.status.partially_recognized': 'Partially Recognized',
    'deferred-revenue.status.fully_recognized': 'Fully Recognized',

    // Frequency
    'deferred_revenues.frequency.monthly': 'Monthly',
    'deferred_revenues.frequency.quarterly': 'Quarterly',
    'deferred_revenues.frequency.annually': 'Annually',
    'deferred_revenues.frequency.weekly': 'Weekly',
    'deferred_revenues.frequency.bi-weekly': 'Bi-Weekly',
    'deferred-revenue.frequency.monthly': 'Monthly',
    'deferred-revenue.frequency.quarterly': 'Quarterly',
    'deferred-revenue.frequency.annually': 'Annually',
    'deferred-revenue.frequency.weekly': 'Weekly',
    'deferred-revenue.frequency.bi-weekly': 'Bi-Weekly',
};
